import { render } from "./ConfigForm.vue?vue&type=template&id=706b847d&scoped=true"
import script from "./ConfigForm.vue?vue&type=script&lang=js"
export * from "./ConfigForm.vue?vue&type=script&lang=js"

import "./ConfigForm.vue?vue&type=style&index=0&id=706b847d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706b847d"]])

export default __exports__